import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthData } from '../models/auth-data.model';
import { UsersService } from 'src/app/configurations/services/users.service';
import { AccountsService } from 'src/app/configurations/services/accounts.service';

@Injectable()
export class AuthService {
  private selectedAccount = new BehaviorSubject<string>("");
  selectedAccount$ = this.selectedAccount.asObservable();
  authChange = new Subject<boolean>();
  redirectPathKey = 'redirectPath';
  accountKey = 'acc';
  userAccounts: string[] = [];
  defaultAccount: string;

  constructor(private oauthService: OAuthService, private userService: UsersService, private accountService: AccountsService) {
    let accountKey = localStorage.getItem(this.accountKey);

    if (!accountKey) {
      this.defaultAccount = this.getDefaultAccountId();
      if (this.defaultAccount) {
        localStorage.setItem(this.accountKey, this.defaultAccount);
        accountKey = this.defaultAccount;
      }
    }

    this.selectedAccount.next(accountKey);
    this.userAccounts = this.getAccounts();
    this.getErrors();
  }

  login() {
    localStorage.setItem(this.redirectPathKey, window.location.pathname)
    this.oauthService.initImplicitFlow();

    if (this.isAuthenticated()) {
      this.authChange.next(true);
    }
  }

  logout() {
    this.oauthService.logOut();
    if (!this.isAuthenticated()) {
      this.authChange.next(false);
    }
  }

  getAuthData(): AuthData {
    if (this.oauthService) {
      let claims = this.oauthService.getIdentityClaims();
      if (claims) {
        let auth = new AuthData();
        auth.username = claims["http://promobid.promob.com/identity/security/claims/username"];
        auth.accountID = claims["http://promobid.promob.com/identity/security/claims/defaultaccountid"];
        auth.accounts = claims["http://promobid.promob.com/identity/security/claims/accountid"];
        auth.token = this.oauthService.getIdToken();

        return auth;
      }
    }
    return null;
  }

  isAuthenticated(): boolean {
    return this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken();
  }

  setSelectedAccountId(id: string) {
    if (this.userAccounts.indexOf(id) > -1)
      this.selectedAccount.next(id);
  }

  getDefaultAccountId(): string {
    let claims = this.oauthService.getIdentityClaims();

    if (claims) {
      return claims["http://promobid.promob.com/identity/security/claims/defaultaccountid"];
    }
  }

  getAccounts(): string[] {
    const claims = this.oauthService.getIdentityClaims();
    if (claims) {
      let claimsList = [];
      let accountClaims = claims["http://promobid.promob.com/identity/security/claims/accountid"];
      if (typeof accountClaims === "string") {
        claimsList.push(accountClaims);
      } else {
        claimsList = claimsList.concat(accountClaims);
      }
      return claimsList;
    }
  }

  getErrors() {
    this.oauthService.events.subscribe(event => {
      if (event.type === 'token_error' || event.type === 'code_error' || event.type === 'discovery_document_load_error') {
        console.error('OAuth Error:', event);
      }
    });
  }
}